import {createFilter} from 'react-select';
import type {GroupBase, PropsValue, SingleValue} from 'react-select';
import {SelectOptionType} from '@guestapp/sdk';
// eslint-disable-next-line import/no-unresolved
import {FilterOptionOption} from 'react-select/dist/declarations/src/filters';

const customFilter = <T, V, L>(
  option: FilterOptionOption<SelectOptionType<T, V, L>>,
  inputValue: string,
) => {
  const filter = createFilter<SelectOptionType<T, V, L>>({
    ignoreAccents: true,
    ignoreCase: true,
    matchFrom: 'any',
  });
  return filter(option, inputValue);
};

function isSingleValue<T>(value: PropsValue<T>): value is SingleValue<T> {
  return !Array.isArray(value);
}

function isGroup<T, V, L>(
  value: SelectOptionType<T, V, L> | GroupBase<SelectOptionType<T, V, L>>,
): value is GroupBase<SelectOptionType<T, V, L>> {
  return 'options' in value;
}

export {customFilter, isSingleValue, isGroup};
